import { useSelector, shallowEqual } from 'react-redux';

const useAuth = () => useSelector(state => state.auth.data, shallowEqual);

export default useAuth;
